__turbopack_context__.v({
  "date": "DateTimeSelector-module__MK_45G__date" + " " + __turbopack_context__.i(605089)["background"] + " " + __turbopack_context__.i(605089)["focusOutline"],
  "error": "DateTimeSelector-module__MK_45G__error",
  "time": "DateTimeSelector-module__MK_45G__time" + " " + __turbopack_context__.i(605089)["background"] + " " + __turbopack_context__.i(605089)["focusOutline"],
  "timeContainer": "DateTimeSelector-module__MK_45G__timeContainer",
});
